/* eslint-disable jsx-a11y/control-has-associated-label, react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'wouter';

import useOpenedState from '../../../hooks/useOpenedState';
import * as AppPropTypes from '../../../lib/PropTypes';

import { useThemeClassName } from '../../../contexts/ThemeContext';
import CircleFacebook from '../../icons/CircleFacebook';
import CloseIcon from '../../icons/Close';
import Instagram from '../../icons/Instagram';
import HeaderDefault from '../../partials/HeaderDefault';
import OtherLocales from '../../partials/OtherLocales';

// import Footer from './Footer';
import styles from '../../../../styles/themes/voisin/header-voisin.module.scss';

const propTypes = {
    className: PropTypes.string,
    pageUrls: AppPropTypes.pageUrls,
    footerMenuItems: AppPropTypes.menuItems,
};

const defaultProps = {
    className: null,
    pageUrls: null,
    footerMenuItems: null,
};

function HeaderCoorslive({ className, pageUrls, footerMenuItems, ...props }) {
    const openedState = useOpenedState();
    const { locale } = useIntl();
    const { menuOpened } = openedState;
    const themeClassName = useThemeClassName(styles);
    const [pathname] = useLocation();
    const isHome = pathname === '/' || pathname.match(/^\/(fr|en)\/?$/) !== null;

    return (
        <HeaderDefault
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [styles.centered]: isHome,
                    [className]: className !== null,
                    [styles.menuOpened]: menuOpened,
                },
            ])}
            innerClassName={styles.inner}
            contentClassName={styles.content}
            fixedContentClassName={styles.fixedContent}
            togglerClassName={styles.toggler}
            togglerOpenedClassName={styles.togglerOpened}
            toggleContentClassName={styles.toggleContent}
            logoButtonClassName={styles.logoButton}
            logoClassName={styles.logo}
            menuClassName={styles.menu}
            itemsClassName={styles.menuItems}
            itemClassName={styles.menuItem}
            openedState={openedState}
            withoutOtherLocales
            menuLabel={
                menuOpened ? (
                    <div className={styles.togglerLabel}>
                        <CloseIcon className={styles.icon} />
                    </div>
                ) : (
                    <div className={styles.togglerLabel}>
                        {/* {!isHome ? ( */}
                        <span>
                            <FormattedMessage defaultMessage="Menu" description="button label" />
                        </span>
                        {/* ) : null} */}
                        {/* <BurgerIcon className={styles.icon} /> */}
                    </div>
                )
            }
            menuChildren={
                <div className={styles.footer}>
                    <OtherLocales
                        className={styles.otherLocales}
                        linkClassName={styles.otherLocale}
                        pageUrls={pageUrls}
                    />
                    <div className={styles.socials}>
                        <ul className={styles.items}>
                            <li className={styles.item}>
                                <a
                                    href="https://www.facebook.com/ChezMonVoisin"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                >
                                    <CircleFacebook className={styles.icon} />
                                </a>
                            </li>
                            <li className={styles.item}>
                                <a
                                    href={`https://www.instagram.com/voisinqc/?hl=${locale}`}
                                    target="_blank"
                                    rel="noreferrer noopener"
                                >
                                    <Instagram className={styles.icon} />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            }
            {...props}
        />
    );
}

HeaderCoorslive.propTypes = propTypes;
HeaderCoorslive.defaultProps = defaultProps;

export default HeaderCoorslive;
